export const fiscalYearEndMonthOptions = [
  { value: '1', label: 'January 31' },
  { value: '2', label: 'February 28' },
  { value: '3', label: 'March 31' },
  { value: '4', label: 'April 30' },
  { value: '5', label: 'May 31' },
  { value: '6', label: 'June 30' },
  { value: '7', label: 'July 31' },
  { value: '8', label: 'August 31' },
  { value: '9', label: 'September 30' },
  { value: '10', label: 'October 31' },
  { value: '11', label: 'November 30' },
  { value: '12', label: 'December 31' },
] as const;

export const getFiscalStartMonthFromYearEnd = (fiscalYearEnd: number) =>
  fiscalYearEnd === 12 ? 1 : fiscalYearEnd + 1;

export const getFiscalYearEndFromStartMonth = (fiscalStartMonth: number) =>
  fiscalStartMonth === 1 ? 12 : fiscalStartMonth - 1;
